const manage_social_status_tabs = ( attr ) =>
{
  cached_elements.set_attribute( '.social__status', 'data-activetab', attr );
}